// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XIbz","index":"styles_index__7rfzv"};